var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleArrow = function SvgCircleArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 33 32"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--custom-fill-color, currentColor)",
    strokeMiterlimit: 10,
    strokeWidth: 2,
    d: "M7.507 15.89h16.518"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--custom-fill-color, currentColor)",
    d: "m18.449 22.78-1.154-1.23 6.082-5.66-6.082-5.652L18.449 9l7.404 6.89z"
  })));
};
export default SvgCircleArrow;